/* PS Header Combined
  - Mobile overlay toggle + panel navigation
  - Perf:
    * Global guard so even if script tag appears multiple times, logic boots once
    * Per-section init guard to avoid double listeners on theme editor reload
    * ResizeObserver to update --ps-header-offset without frequent window listeners
*/

(function () {
  if (window.__PS_HEADER_COMBINED_BOOTED__) return;
  window.__PS_HEADER_COMBINED_BOOTED__ = true;

  var BP_MAX = 989;

  function qs(root, sel) {
    return root ? root.querySelector(sel) : null;
  }
  function qsa(root, sel) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : [];
  }

  function setHeaderOffsetVar(headerMain) {
    if (!headerMain) return;
    var bottom = headerMain.getBoundingClientRect().bottom || 0;
    document.documentElement.style.setProperty('--ps-header-offset', bottom + 'px');
  }

  function initOne(root) {
    if (!root || root.__psHeaderCombinedInited) return;
    root.__psHeaderCombinedInited = true;

    var headerMain = qs(root, '[data-ps-header-main]');
    var navRoot = qs(root, '[data-ps-header-nav]');
    var toggleBtn = qs(root, '[data-ps-header-menu-toggle]');
    if (!headerMain || !navRoot || !toggleBtn) return;

    var overlay = qs(navRoot, '[data-ps-mobile-overlay]');
    var panelsWrap = qs(navRoot, '[data-ps-panels]');
    if (!overlay || !panelsWrap) return;

    // Initial offset (fast)
    setHeaderOffsetVar(headerMain);

    // ResizeObserver: offset update when header layout changes (logo/font load, editor changes)
    var ro = null;
    if ('ResizeObserver' in window) {
      ro = new ResizeObserver(function () {
        setHeaderOffsetVar(headerMain);
      });
      ro.observe(headerMain);
    } else {
      // Fallback: low-frequency resize only
      var onResize = function () {
        setHeaderOffsetVar(headerMain);
        // Close overlay when switching to desktop
        if (window.innerWidth > BP_MAX && overlay.classList.contains('is-open')) {
          setOpen(false);
        }
      };
      window.addEventListener('resize', onResize, { passive: true });
      window.addEventListener('orientationchange', onResize, { passive: true });
      root.__psHeaderCombinedCleanup = function () {
        window.removeEventListener('resize', onResize);
        window.removeEventListener('orientationchange', onResize);
      };
    }

    function setOpen(isOpen) {
      overlay.classList.toggle('is-open', isOpen);
      overlay.setAttribute('aria-hidden', String(!isOpen));
      document.documentElement.classList.toggle('ps-mobile-menu-open', isOpen);
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      toggleBtn.setAttribute('aria-expanded', String(isOpen));
    }

    function activatePanel(name) {
      var panels = qsa(panelsWrap, '[data-ps-panel]');
      for (var i = 0; i < panels.length; i++) panels[i].classList.remove('is-active', 'is-left');

      var rootPanel = qs(panelsWrap, '[data-ps-panel="root"]');
      if (!rootPanel) return;

      if (name === 'root') {
        rootPanel.classList.add('is-active');
        return;
      }

      var target = qs(panelsWrap, '[data-ps-panel="' + name + '"]');
      if (!target) return;

      rootPanel.classList.add('is-left');
      target.classList.add('is-active');
    }

    // Toggle click
    toggleBtn.addEventListener('click', function () {
      setHeaderOffsetVar(headerMain);
      var isOpen = overlay.classList.contains('is-open');
      if (!isOpen) activatePanel('root');
      setOpen(!isOpen);
    });

    // Backdrop close
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) setOpen(false);
    });

    // Panel navigation (delegation)
    panelsWrap.addEventListener('click', function (e) {
      var go = e.target.closest && e.target.closest('[data-ps-go]');
      if (go) {
        activatePanel(go.getAttribute('data-ps-go'));
        return;
      }
      var back = e.target.closest && e.target.closest('[data-ps-back]');
      if (back) {
        activatePanel('root');
        return;
      }
    });

    // Escape close (global, but only one listener overall due to boot guard)
    // We'll store list of overlays to close on esc
    if (!window.__PS_HEADER_COMBINED_ESC__) {
      window.__PS_HEADER_COMBINED_ESC__ = true;
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        qsa(document, '.ps-header-nav__mobile-overlay.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          el.setAttribute('aria-hidden', 'true');
        });
        document.documentElement.classList.remove('ps-mobile-menu-open');
        document.documentElement.style.overflow = '';
        qsa(document, '[data-ps-header-menu-toggle][aria-expanded="true"]').forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
      });
    }

    // Cleanup hook for theme editor (optional)
    root.__psHeaderCombinedDestroy = function () {
      if (ro) ro.disconnect();
      if (root.__psHeaderCombinedCleanup) root.__psHeaderCombinedCleanup();
    };
  }

  function bootAll() {
    qsa(document, '[data-ps-header-combined]').forEach(initOne);
  }

  // Normal load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  // Theme editor reload: init newly loaded section
  document.addEventListener('shopify:section:load', function (e) {
    var container = e && e.target ? e.target : null;
    if (!container || !container.querySelector) return bootAll();
    var root = container.querySelector('[data-ps-header-combined]');
    if (root) initOne(root);
    else bootAll();
  });

  // Theme editor unload: cleanup (avoid observers/listeners leak)
  document.addEventListener('shopify:section:unload', function (e) {
    var container = e && e.target ? e.target : null;
    if (!container || !container.querySelector) return;
    var root = container.querySelector('[data-ps-header-combined]');
    if (root && root.__psHeaderCombinedDestroy) root.__psHeaderCombinedDestroy();
  });
})();